// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__7pAea","itemRound":"Select_itemRound__LcObX","popup":"Select_popup__OVAsF","isSelectProduct":"Select_isSelectProduct__VyR-O"};